import {
  getTemplateTagLabel,
  type TemplateTag,
  type TemplateTagChannelBranch,
} from 'src/data/template';

/**
 * Sidebar tab types
 * @enum {string}
 * @property {SIDEBAR_TAB_TYPE} DEFAULT - default generation tool
 */
export const SIDEBAR_TAB_TYPE = {
  all: 'all',
  recentlyUsed: 'recently_used',
  savedTemplates: 'saved_templates',
  templateTag: 'template_tag',
} as const;

export const DEFAULT_SIDEBAR_TAB_TYPE = SIDEBAR_TAB_TYPE.recentlyUsed;

export const SIDEBAR_TAB_ALL = {
  type: SIDEBAR_TAB_TYPE.all,
  label: 'All',
};
export const SIDEBAR_TAB_RECENTLY_USED = {
  type: SIDEBAR_TAB_TYPE.recentlyUsed,
  label: 'Recently used',
};
export const SIDEBAR_TAB_SAVED_TEMPLATES = {
  type: SIDEBAR_TAB_TYPE.savedTemplates,
  label: 'Your saved templates',
};

export interface SidebarTemplateTagTab {
  type: typeof SIDEBAR_TAB_TYPE.templateTag;
  templateTag: TemplateTag;
  /** The one branch of the tag being shown, or every template of the tag when it has no branches. */
  channelBranch: TemplateTagChannelBranch | null;
  label: string;
}

export const createSidebarTemplateTagTab = (
  templateTag: TemplateTag,
  channelBranch?: TemplateTagChannelBranch
): SidebarTemplateTagTab => ({
  type: SIDEBAR_TAB_TYPE.templateTag,
  templateTag,
  channelBranch: channelBranch || null,
  label: channelBranch ? channelBranch.label : getTemplateTagLabel(templateTag),
});
